import { AlInputComponent } from './al-input/al-input.component';
import { AlLabelComponent } from './al-label/al-label.component';
import { AlFieldsetComponent } from './al-fieldset/al-fieldset.component';
import { AlHintComponent } from './al-hint/al-hint.component';
import { AlTipComponent } from './al-tip/al-tip.component';
import { AlRadioComponent } from './al-radio/al-radio.component';
// AlCheckboxComponent - already exists in NGCC, so using variatoon below for new version
import { AlChkboxComponent } from './al-checkbox/al-checkbox.component';
import { AlCheckboxGroupComponent } from './al-checkbox-group/al-checkbox-group.component';
import { AlSelectComponent } from './al-select/al-select.component';
import { AlMultiSelectComponent } from './al-multiselect/al-multiselect.component';
import { AlTextAreaComponent } from './al-textarea/al-textarea.component';
import { AlFormGroupComponent } from './al-form-group/al-form-group.component';
import { AlFormGroupErrorsComponent } from './al-form-group-errors/al-form-group-errors.component';
import { AlButtonComponent } from './al-button/al-button.component';
import { AlButtonGroupComponent } from './al-button-group/al-button-group.component';
import { AlWrapperComponent } from './al-wrapper/al-wrapper.component';
import { AlIconComponent } from './al-icon/al-icon.component';
import { AlTabsComponent } from './al-tabs/al-tabs.component';
import { AlTabComponent } from './al-tabs/al-tab/al-tab.component';
import { AlMenuComponent } from './al-menu/al-menu.component';
import { AlDropdownComponent } from './al-dropdown/al-dropdown.component';


const ALL_NEW_COMMON = [
    AlInputComponent,
    AlLabelComponent,
    AlIconComponent,
    AlFieldsetComponent,
    AlHintComponent,
    AlTipComponent,
    AlRadioComponent,
    AlChkboxComponent,
    AlCheckboxGroupComponent,
    AlSelectComponent,
    AlMultiSelectComponent,
    AlTextAreaComponent,
    AlFormGroupComponent,
    AlFormGroupErrorsComponent,
    AlButtonComponent,
    AlButtonGroupComponent,
    AlWrapperComponent,
    AlTabsComponent,
    AlTabComponent,
    AlMenuComponent,
    AlDropdownComponent
];

export {
    ALL_NEW_COMMON,
    AlInputComponent,
    AlLabelComponent,
    AlIconComponent,
    AlFieldsetComponent,
    AlHintComponent,
    AlTipComponent,
    AlRadioComponent,
    AlChkboxComponent,
    AlCheckboxGroupComponent,
    AlSelectComponent,
    AlMultiSelectComponent,
    AlTextAreaComponent,
    AlFormGroupComponent,
    AlFormGroupErrorsComponent,
    AlButtonComponent,
    AlButtonGroupComponent,
    AlWrapperComponent,
    AlTabsComponent,
    AlTabComponent,
    AlMenuComponent,
    AlDropdownComponent
};
